import React, { useState, useMemo } from 'react';
import Brushaway from '@components/Brushaway';
import { Button } from '@ui';
import { FireIcon } from '@icons/FireIcon';
import { translate } from '@utils/i18n';
import NewItemSection from './components/NewItemSection';
import first from './animations/first.json';
import second from './animations/second.json';
import third from './animations/third.json';
import fourth from './animations/fourth.json';
import './WhatsNewModalStyles.scss';
const namespace = 'whats_new_modal';
const DISMISS_KEY = 'plg-ai-launch-banner-dismissed';
const PRODUCT_PAGE_URL = 'https://www.inspectpoint.com/inspection-assistant-customer-product';
const TABS = [
    {
        id: 'inspection_assistant',
        tabLabel: translate('feature_1', { namespace }),
        title: translate('feature_1_title', { namespace }),
        description: translate('feature_1_description', { namespace }),
        animationData: first,
        animationHeight: 297
    },
    {
        id: 'proposal_assistant',
        tabLabel: translate('feature_2', { namespace }),
        title: translate('feature_2_title', { namespace }),
        description: translate('feature_2_description', { namespace }),
        animationData: second,
        animationHeight: 270
    },
    {
        id: 'fire_code_expert',
        tabLabel: translate('feature_3', { namespace }),
        title: translate('feature_3_title', { namespace }),
        description: translate('feature_3_description', { namespace }),
        animationData: third,
        animationHeight: 297
    },
    {
        id: 'sales_assistant',
        tabLabel: translate('feature_4', { namespace }),
        title: translate('feature_4_title', { namespace }),
        description: translate('feature_4_description', { namespace }),
        animationData: fourth,
        animationHeight: 270
    }
];
export default function WhatsNewModal({ isOpen, onClose, showTalkToSales = true }) {
    const [activeTab, setActiveTab] = useState(TABS[0].id);
    const activeTabContent = TABS.find((tab) => tab.id === activeTab) || TABS[0];
    // Check if the banner was dismissed in localStorage
    const isDismissed = useMemo(() => {
        try {
            return localStorage.getItem(DISMISS_KEY) === 'true';
        }
        catch (error) {
            console.warn('Failed to read dismiss preference from localStorage:', error);
            return false;
        }
    }, []);
    const handleTalkToSales = () => {
        // Open product page in new tab with security headers
        window.open(PRODUCT_PAGE_URL, '_blank', 'noopener,noreferrer');
    };
    return (React.createElement(Brushaway, { open: isOpen, onClose: onClose, title: translate('title', { namespace }), isForm: false, minWidth: 960, wrapperContentClassName: "whats-new-modal", customFooter: React.createElement("div", { className: "whats-new-modal__footer" },
            React.createElement(Button, { type: "button", onClick: onClose }, translate('close', { namespace })),
            showTalkToSales && !isDismissed && (React.createElement(Button, { type: "button", variant: "primary", onClick: handleTalkToSales }, translate('talk_to_sales', { namespace })))) },
        React.createElement("div", { className: "whats-new-modal__content" },
            React.createElement("div", { className: "whats-new-modal__layout" },
                React.createElement("div", { className: "whats-new-modal__sidebar" },
                    React.createElement(FireIcon, { width: 38, height: 48 }),
                    React.createElement("h3", { className: "whats-new-modal__sidebar-title" }, translate('streamline_quality', { namespace })),
                    React.createElement("p", { className: "whats-new-modal__sidebar-subtitle" }, translate('intelligently_check', { namespace })),
                    React.createElement("ul", { className: "whats-new-modal__tabs" }, TABS.map((tab) => (React.createElement("li", { key: tab.id, className: "whats-new-modal__tab-item" },
                        React.createElement("button", { type: "button", className: `whats-new-modal__tab ${activeTab === tab.id ? 'whats-new-modal__tab--active' : ''}`, onClick: () => setActiveTab(tab.id) },
                            React.createElement("span", { className: "whats-new-modal__tab-text" }, tab.tabLabel))))))),
                React.createElement("div", { className: "whats-new-modal__main" },
                    React.createElement(NewItemSection, { title: activeTabContent.title, description: activeTabContent.description, animationData: activeTabContent.animationData, animationHeight: activeTabContent.animationHeight }))))));
}
